import { storeToRefs } from 'pinia'
import { readonly } from 'vue'
import { useToastStore, type ToastContent, type ToastInput } from '../stores/toast.store'

export function useTqToast() {
  const store = useToastStore()
  const { toasts } = storeToRefs(store)

  return {
    toasts: readonly(toasts),
    show: (input: ToastInput) => store.show(input),
    success: (content: ToastContent | string, message?: string) => store.success(content, message),
    error: (content: ToastContent | string, message?: string) => store.error(content, message),
    warning: (content: ToastContent | string, message?: string) => store.warning(content, message),
    info: (content: ToastContent | string, message?: string) => store.info(content, message),
    dismiss: (id: string) => store.dismiss(id),
    clearAll: () => store.clearAll()
  }
}
